import { render, staticRenderFns } from "./ProfileInfoTable.vue?vue&type=template&id=0b53a53b&scoped=true"
import script from "./ProfileInfoTable.vue?vue&type=script&lang=js"
export * from "./ProfileInfoTable.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfoTable.vue?vue&type=style&index=0&id=0b53a53b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53a53b",
  null
  
)

export default component.exports